import React from 'react';
import { Header, Image, Divider } from 'semantic-ui-react';
import { PayPalForm, PlanDetail } from '@emyw/pay-lib';
import { ButtonLink } from '@emyw/auth-lib';
import { getPlanCostLabel } from '../utils';
import '../custom-theme.css';
var REACT_APP_ACCOUNT_API_IMAGE_PATH = process.env.REACT_APP_ACCOUNT_API_IMAGE_PATH;

var Step3PayPal = function Step3PayPal(_ref) {
  var onComplete = _ref.onComplete,
      onChangePlanClick = _ref.onChangePlanClick,
      onChangePaymentClick = _ref.onChangePaymentClick,
      user = _ref.user,
      planSelectDisabled = _ref.planSelectDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "wizardStepBase payPal"
  }, /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h2",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    size: "large",
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/circle-secure.png")
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "stepTitleChangeable"
  }, "Set up your PayPal.", /*#__PURE__*/React.createElement(Header.Subheader, {
    className: "stepChange"
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onChangePaymentClick
  }, "Change payment method")), planSelectDisabled && /*#__PURE__*/React.createElement(Header.Subheader, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, getPlanCostLabel(user).label1, /*#__PURE__*/React.createElement("br", null), getPlanCostLabel(user).label2)))))), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscribeStepContent"
  }, !planSelectDisabled && /*#__PURE__*/React.createElement(PlanDetail, {
    user: user,
    secondary: true,
    onChangePlanClick: onChangePlanClick
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(PayPalForm, {
    onComplete: onComplete,
    onChangePlanClick: onChangePlanClick,
    user: user
  })));
};

export default Step3PayPal;